import { XCircleIcon } from '@heroicons/react/solid';
import { Modal as ModalAntd } from 'antd';
import React from 'react';
const Modal = ({ children, title, open, onCancel, ...restProps }) => {
    return (React.createElement(ModalAntd, { open: open, width: 1024, className: "rounded-xl", onCancel: onCancel, closeIcon: React.createElement(XCircleIcon, { width: 26, height: 26, className: "text-grayScale05 cursor-pointer" }), title: React.createElement("span", { className: "text-sm md:text-2xl font-medium leading-6 text-gray-900 flex justify-between w-full" }, title || ''), ...restProps }, children));
};
export default Modal;
